import { useCallback } from 'react'

import { useQuery, useQueryClient } from '@tanstack/react-query'

import { useApi } from '@fortem-monorepo/react-spa'

export const useInstrumentTypesQuery = () => {
  const api = useApi()

  return useQuery({
    queryKey: ['instruments', 'types'],
    queryFn: () => api.instruments.getInstrumentTypes(),
  })
}

export const useInstrumentsByTypeQuery = (instrument_type_ids: (string | number)[]) => {
  const api = useApi()

  return useQuery({
    queryKey: ['instruments', 'type', instrument_type_ids],
    queryFn: () => api.instruments.getInstrumentsByType(instrument_type_ids),
    enabled: instrument_type_ids !== undefined && instrument_type_ids !== null,
  })
}

export const useInstrumentsByIds = (instrumentIds: number[]) => {
  const api = useApi()

  return useQuery({
    queryKey: ['instruments', 'lookup', instrumentIds],
    queryFn: () => api.instruments.getInstrumentsByIds(instrumentIds),
    enabled: instrumentIds.length > 0,
  })
}

export const useCacheInstruments = () => {
  const api = useApi()

  const queryClient = useQueryClient()

  const cache = useCallback(async (instrumentIds: number[]) => {
    const ids = [...new Set(instrumentIds)].sort((a, b) => a - b)

    const instruments = await api.instruments.getInstrumentsByIds(ids)

    if (instruments ?? [].length > 0) {
      for (const instrument of instruments) {
        queryClient.setQueryData(['instrument', instrument.instrument_id], instrument)
      }
    }
  }, [])

  return cache
}
